module.exports = __webpack_public_path__ + "static/media/steak.9c6adc9e.svg";